export const model = {
    id: null,
    patientIndicatorName: [],
    patientIndicatorIndeces:[],
    created_at: '',
    updated_at: ''
};
